import { useSelector } from 'src/utils/store'
import { useDispatch } from 'react-redux'
import { actions } from '../../StockManagementState'
import { useForm } from 'react-hook-form'
import { FlvProductsUpdateAvailability, FlvRuleDayPeriodEnum } from '../../StockManagementTypes'
import FlvProductsTable from '../FlvProductsTable/FlvProductsTable'
import * as S from './FormResendUpdateFlv.styles'
import { Typography } from '@mui/material'

const FormResendUpdateFlv = () => {
  const { selectedFlvProducts, flvRuleDayPeriod } = useSelector((state) => state.stockManagement)
  const { handleSubmit } = useForm()
  const dispatch = useDispatch()

  const groupedProductsToResend = (): FlvProductsUpdateAvailability[] => {
    const groupedProducts = selectedFlvProducts.reduce((acc, product) => {
      const key = product.idFulfillmentCenter
      if (!acc[key]) {
        acc[key] = {
          idsModel: [],
          idFulfillmentCenter: product.idFulfillmentCenter,
        }
      }
      acc[key].idsModel.push(product.idModel)
      return acc
    }, {})

    return Object.values(groupedProducts)
  }

  const onSubmitResendUpdateFlv = () => {
    if (selectedFlvProducts.length === 0 || !flvRuleDayPeriod) {
      return
    }

    const groupedProducts = groupedProductsToResend()

    dispatch(actions.resendUpdateForFlvRelease({
      dayPeriod: flvRuleDayPeriod.toLowerCase(),
      products: groupedProducts,
    }))
  }

  return (
    <S.Form onSubmit={handleSubmit(onSubmitResendUpdateFlv)}>
      <FlvProductsTable />
      <S.ContainerBottom>
        <Typography variant='body1' sx={{ alignSelf: 'center' }}>
          {flvRuleDayPeriod && `REGRA SELECIONADA: ${FlvRuleDayPeriodEnum[flvRuleDayPeriod.toUpperCase()].toUpperCase()}`}
        </Typography>
        <S.CustomButton
          title='Reenviar atualização'
          type='submit'
          bgColor='blue'
          hoverColor='darkBlueHover'
          letterColor='white'
          data-testid='resend-update-flv-test-id'
          disabled={selectedFlvProducts.length === 0 || !flvRuleDayPeriod}
        />
      </S.ContainerBottom>
    </S.Form>
  )
}

export default FormResendUpdateFlv
